import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'gdp-equipment-table',
  templateUrl: './equipment-table.component.html',
  styleUrls: ['./equipment-table.component.scss']
})
export class EquipmentTableComponent implements OnInit {
  @Input() equipmentList: Array<any> = [];
  @Input() loading: boolean = false;
  @Input() loadingLines: Array<number>;
  public sort: any = {}; // TODO: this object remain empty until backend sorting is ready
  
  constructor(
    private router: Router
  ) { }

  ngOnInit() {}

  toggleSort(key: string) {
    const currentValue = this.sort[key];
    if (currentValue) {
      this.sort[key] = currentValue === 'asc' ? 'desc' : undefined;
    } else {
      this.sort[key] = 'asc';
    }
  }
}
